import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { WhiteContainer } from "UI";
import { Editable, View } from "./partials";
import Group from "models/groups";
import Helpers from "utils/Helpers";
import useAuthContainer from "stores/Auth";
import { v4 as uuidv4 } from "uuid";

const Contacts = ({ contacts: initialContacts, groupId }) => {
	const { t } = useTranslation();
	const [contacts, setContacts] = useState(initialContacts);
	const [selected, setSelected] = useState(null);
	const [open, setOpen] = useState(false);
	const { user, userAccount } = useAuthContainer.useContainer();
	const GroupEntity = React.useMemo(() => new Group(), [groupId]);

	useEffect(() => {
		setContacts(initialContacts);
	}, [initialContacts]);

	const saveContact = useCallback(
		async (data) => {
			const updatedContacts = selected
				? Helpers.deepArrayUpdate(contacts, data, data.id)
				: [
						...contacts,
						{
							by: `${userAccount?.additionalDatas?.name || ""} ${
								userAccount?.additionalDatas?.lastname || ""
							}`,
							uid: user.uid,
							...data,
							id: uuidv4(),
						},
				  ];
			setSelected(null);

			setContacts(updatedContacts);
			GroupEntity.contacts = updatedContacts;
			await GroupEntity.updateGroup(groupId);
		},
		[
			contacts,
			selected,
			user.uid,
			userAccount?.additionalDatas,
			GroupEntity,
		],
	);

	const deleteContact = useCallback(
		async (id) => {
			const updatedContacts = contacts.filter(
				(contact) => contact.id !== id,
			);
			setContacts(updatedContacts);
			GroupEntity.contacts = updatedContacts;
			await GroupEntity.updateGroup(groupId);
		},
		[contacts, GroupEntity],
	);

	return (
		<WhiteContainer title={t("contacts")}>
			<View
				contacts={contacts}
				select={(contact) => {
					setSelected(contact);
					setOpen(true);
				}}
			/>
			<Editable
				deleteContact={deleteContact}
				saveContact={saveContact}
				open={open}
				close={() => setOpen(false)}
				selected={selected}
			/>
		</WhiteContainer>
	);
};

export default Contacts;
